// module.exports = {
// 	GLOBAL_PATH: '/diag'
// };

export const GLOBAL_PATH = '/diag';